import { render, staticRenderFns } from "./Personalization.vue?vue&type=template&id=6fb6495d&scoped=true"
import script from "./Personalization.vue?vue&type=script&lang=ts"
export * from "./Personalization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6495d",
  null
  
)

export default component.exports